import { ProductsSection } from '@ui/product/products-section.tsx';
import { usePopularProducts } from './use-popular-product';
import { useNavigate } from 'react-router-dom';

export const PopularProducts = () => {
  const { data } = usePopularProducts();
  const navigate = useNavigate();

  return (
    <ProductsSection
      title="Популярные товары"
      items={data}
      onPress={() => navigate('/popular')}
    />
  );
};
